<button
  *ngIf="variant === 'detail'"
  type="button"
  class="back-button back-button--detail"
  [class.back-button--with-margin]="withBottomMargin"
  [attr.aria-label]="label"
  (click)="onClick($event)"
>
  <img class="back-button__icon" src="../../../../assets/icons/arrow-left.svg" alt="" role="presentation" />
  <span class="back-button__text">{{ label }}</span>
</button>

<a
  *ngIf="variant === 'checkout'"
  href="#"
  class="back-button back-button--checkout"
  [attr.aria-label]="label"
  (click)="onClick($event)"
>
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7" />
  </svg>
  {{ label }}
</a>
